// composables/useLog.js
import {useEnvironment} from "@/composables/useEnvironment";

const {isTest, isProduction} = useEnvironment();

function fileStem(url) {
  try {
    const cleaned = url.toString().split("?")[0];
    const segments = cleaned.split("/");
    const last = segments[segments.length - 1] || "";
    return last.replace(/\.[^.]+$/, "");
  } catch {
    return;
  }
}

function resolveComponentName(source) {
  if (!source) return;
  if (typeof source === "string") return source;
  if (typeof source === "object" && typeof source.url === "string") {
    return fileStem(source.url);
  }
  return;
}

export function useLog(source, mode = "") {
  const isPublic = isTest || isProduction;
  const disablePublicLogging = mode === "";
  const noOperation = () => {};
  if (!source) return noOperation;
  if (isPublic && disablePublicLogging) return noOperation;
  const componentName = resolveComponentName(source);
  if (!componentName) return noOperation;
  return (msg) => console.log(`${componentName}: ${msg}`);
}
